import { YearlyReport, OrdersMonthSummary } from '../../../models';

export const getYearlyReport = (data: any): YearlyReport => {
  return {
    orders: data.orders.map(getOrder)
  };
}

const getOrder = (data: any): OrdersMonthSummary => {
  return {
    month: data.month,
    count: data.count,
    basePrice: data.base_price,
    deliveryFee: data.delivery_fee,
    discount: data.discount,
    total: data.total
  };
}
